<template>
  <a v-if="isTeamMember" :href="linkForDriver" target="_top" class="driver-link">
    {{driverFirstname}} {{driverSurname}}
  </a>
  <span v-else>
    {{driverFirstname}} {{driverSurname}}
  </span>
</template>

<script>
import slugify from 'slugify';
import { mapGetters } from 'vuex';

export default {
  name: 'driverLink',
  props: {
    isTeamMember: {
      type: Boolean,
      required: false,
      default: false,
    },
    driverFirstname: {
      type: String,
      required: true,
    },
    driverSurname: {
      type: String,
      required: true,
    },
  },
  computed: {
    linkForDriver () {
      const { locale } = this;
      const driverSlug = `${this.$props.driverFirstname}-${this.$props.driverSurname}`;
      return `/${locale}/team/${locale === 'de' ? 'fahrer' : 'drivers'}/${slugify(driverSlug, { lower: true })}`;
    },
    ...mapGetters([
      'locale',
    ]),
  },
};
</script>

<style lang="scss">
  @import "../styles/components/driverLink";
</style>
